// paymentSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
  termsPlanSelected: false,
  paymentCompleted: false,
};
// This slice is for the maintaining the payment status to preventing the user go back from the payments page
const termsUserActionSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    selectTermsPlan: (state) => {
      // making state default true for plan selected and payment false
      state.termsPlanSelected = true;
      state.paymentCompleted = false;
    },
    completePayment: (state) => {
      state.paymentCompleted = true;
    },
    removeTermsPlan: (state) => {
      state.termsPlanSelected = false;
      state.paymentCompleted = false;
      message.error("Something went wrong!");
    },
  },
});

export const { selectTermsPlan, completePayment, removeTermsPlan } =
  termsUserActionSlice.actions;

export default termsUserActionSlice.reducer;
